const posts = [
  {
    id: 1,
    header: "Hydrogen VS Electric Cars",
    description: "Will hydrogen-fueled cars ever catch up tp EVs?",
  },

  {
    id: 2,
    header: 'The Downsides of AI Artistry',
    description: 'What are the possible adverse effects of on-demand AI image generation'
  },

  {
    id: 3,
    header: 'Is VC Funding Drying Up?',
    description: 'Private funding by VC firms is down 50% YOY. We take a look at what that means.'
  },
];

export default posts;